import { useQuery } from "@tanstack/react-query";
import log from "logbeacon";
import { useOspApiClientProvider } from "@hooks";
import { QUERY_KEYS } from "@config";

const PAGE_SIZE = 10;

interface QueryParamsType {
  dataType?: string;
  pageSize?: number;
  enabled?: boolean;
  symbols?: string[];
  queryParams?: any;
  ids?: string[];
  isPollToken?: boolean;
  useQueryParams?: {
    staleTime?: number;
    gcTime?: number;
  };
}

export const useTokenDetailsMarket = (params: QueryParamsType) => {
  const {
    enabled = true,
    symbols,
    dataType = "24h",
    queryParams,
    isPollToken,
    useQueryParams,
  } = params;
  const { openDataApi } = useOspApiClientProvider();
  const pageLimit =
    symbols?.length || params?.ids?.length || params?.pageSize || PAGE_SIZE;

  const ids = params?.ids ? params?.ids : [];
  const defaultParams = isPollToken ? {} : { "enrich.with_exchange": true };

  const query = {
    limit: pageLimit,
    // symbols: symbols,
    ids,
    "enrich.with_market.enable": true,
    ...defaultParams,
    ...queryParams,
  };
  const queryKey = isPollToken
    ? QUERY_KEYS.POOL_DETAILS_MARKET
    : QUERY_KEYS.TOKEN_DETAILS_MARKET;

  const { data, isLoading, isFetching, isPending, isSuccess } = useQuery({
    enabled: !!openDataApi && enabled,
    queryKey: [queryKey, params, dataType, ids],
    queryFn: async () => {
      try {
        const func = isPollToken
          ? openDataApi!.pools.getPools
          : openDataApi!.tokens.getTokens;
        const { data } = await func(query);
        return data?.data?.rows || [];
      } catch (error) {
        log.error("[Token-Details-Market]", error);
        return [];
      }
    },
    ...useQueryParams,
  });

  return {
    data,
    isLoading,
    isFetching,
    isPending,
    isSuccess,
    queryKey,
  };
};
